<template>
  <div id="menu" class="layout no-wrap align-center">
    <v-menu
      v-model="open"
      max-width="300px"
      max-height="400px"
      :close-on-content-click="false"
      :nudge-width="100"
      offset-y
      attach="#menu"
    >
      <template v-slot:activator="{ on }">
        <slot name="activator" :on="on">
          <v-btn small text v-on="on">
            <div>{{ label }}</div>
            <v-icon>{{ open ? icons.arrows.menu.top : icons.arrows.menu.down }}</v-icon>
          </v-btn>
        </slot>
      </template>
      <v-card>
        <slot name="menu">
          Nothing here
        </slot>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import icons from '@/mixins/icons';
export default {
  name: 'CoreMenu',
  mixins: [icons],
  props: {
    label: String
  },
  data() {
    return {
      open: false
    };
  }
};
</script>

<style></style>
